import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Icon, { ICON_TYPE } from 'components/icon';
import { Anchor } from 'components/base';
import AccountMenu from 'ecommerce/components/user/accountMenu';
import useCartContext from 'ecommerce/context/cart';
import useUserContext from 'ecommerce/context/user';
import BaseHeader from 'components/layout/header';
import store from 'utils/store';

import SETTINGS from '../../settings';
import Nav from './nav';
import ACCOUNT_SECTIONS from '../custom/accountSections';
import { CartPageLink, SignInPageLink, HomePageLink } from '../pageLinks';
import { SESSION_REDIRECT_KEY } from '../../lib/sessionKeys';

const Header = forwardRef((props, ref) => {
  const userContext = useUserContext();
  const cartContext = useCartContext();

  const handleSignOut = () => {
    store.session.remove(SESSION_REDIRECT_KEY);
    userContext.setAccessToken(null);
    userContext.clear();
    cartContext.clear();
  };

  return (
    <BaseHeader
      ref={ref}
      topPosition={props.topPosition}
      showNavigation={props.showNavigation}
      left={
        <HomePageLink>
          <Anchor className="logo">
            <img src="/static/img/logo-mycanvas.svg" alt="MyCanvas" />
          </Anchor>
        </HomePageLink>
      }
      center={({ topPosition, navbarExpanded }) => (
        <Nav topPosition={topPosition} expanded={navbarExpanded} />
      )}
      right={
        <>
          {userContext.accessToken ? (
            <AccountMenu
              sections={ACCOUNT_SECTIONS}
              signOutHref="/signin"
              onSignOut={handleSignOut}
              labelBreakpoint="md"
              avatarClassName="text-body"
            />
          ) : (
            <SignInPageLink>
              <Anchor className="header-nav-link">LOGIN</Anchor>
            </SignInPageLink>
          )}
          <CartPageLink>
            <Anchor className="link-bag">
              <Icon type={ICON_TYPE.CART} />
              {cartContext.length > 0 && (
                <span className="link-bag-count link-bag-count-mycanvas">{cartContext.length}</span>
              )}
            </Anchor>
          </CartPageLink>
          <Anchor className="text-body" href={SETTINGS.HELPDESK_URL} targetBlank>
            <Icon type={ICON_TYPE.HELP} />
          </Anchor>
        </>
      }
    />
  );
});

Header.propTypes = {
  showNavigation: PropTypes.bool,
  topPosition: PropTypes.number,
};

Header.defaultProps = {
  showNavigation: true,
  topPosition: 0,
};

export default Header;
